export const VIEW_TYPE = {
  BOOKING_MANAGEMENT: 'booking_management',
  BOOKING_ASSETS: 'booking_asstes',
  EDIT_BOOKING: 'edit_booking',
  CANCEL_BOOKING: 'cancel_booking',
  VIEW_BOOKING: 'view_booking',
};
